import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'home-dial',
  templateUrl: './home-dialog.component.html',
  styleUrls: ['./home-dialog.component.scss'],
})
export class HomeDialogComponent implements OnInit {
  public isMobile: boolean;
  public ua: string;

  constructor(
    public dialogRef: MatDialogRef<HomeDialogComponent>,
    private route: ActivatedRoute
  ) {
    this.isMobile =
      /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    this.ua = navigator.userAgent;
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params['no-popup'] && params['no-popup'] === 'true')
        this.dialogRef.close();
    });
  }

  onNoClick(): void {
    window.localStorage.setItem('continue', 'true');
    this.dialogRef.close();
  }
}
